import configs from 'configs';

const EMPTY_DEVICE = { info: null, fingerprintId: null, fingerprint: null };

let fingerprintIdPromise = null;

const loadFingerprintService = () => import('@web-mobile/fingerprint-service');

const formatDeviceInfo = collectedInfo => {
  if (!collectedInfo) {
    return null;
  }

  return [collectedInfo.os, collectedInfo.browser].filter(Boolean).join(' · ') || null;
};

export const getDeviceFingerprintId = () => {
  if (!fingerprintIdPromise) {
    fingerprintIdPromise = loadFingerprintService()
      .then(({ getUserHash }) => getUserHash())
      .catch(error => {
        console.warn('Device fingerprint id collection failed', error);
        return null;
      });
  }

  return fingerprintIdPromise;
};

const collectDeviceData = async () => {
  const fingerprintId = await getDeviceFingerprintId();

  if (!configs.geoIpLink) {
    return { ...EMPTY_DEVICE, fingerprintId };
  }

  try {
    const { getUniqueIdentification } = await loadFingerprintService();
    const { userIdentifier, collectedInfo } = (await getUniqueIdentification(configs.geoIpLink)) || {};

    return {
      info: formatDeviceInfo(collectedInfo),
      fingerprintId: userIdentifier || fingerprintId,
      fingerprint: collectedInfo ? JSON.stringify(collectedInfo) : null,
    };
  } catch (error) {
    console.warn('Device info collection failed', error);
    return { ...EMPTY_DEVICE, fingerprintId };
  }
};

export default collectDeviceData;
